export const QUOTA_LIMIT_KINDS = [
  'clip_exports',
  'processing_time',
  'library_curation',
  'library_video_time',
  'library_exports',
  'brand_kits',
  'paid_feature',
] as const;

export type QuotaLimitKind = (typeof QUOTA_LIMIT_KINDS)[number];

export const QUOTA_ERROR_MARKERS: { kind: QuotaLimitKind; marker: string }[] = [
  { kind: 'library_curation', marker: 'Library curation limit reached' },
  { kind: 'library_video_time', marker: 'Library video time limit reached' },
  { kind: 'library_exports', marker: 'Library export limit reached' },
  { kind: 'clip_exports', marker: 'Not enough clips' },
  { kind: 'processing_time', marker: 'Not enough processing seconds' },
  { kind: 'paid_feature', marker: 'Upgrade to a paid plan' },
];

export function collectErrorMessages(error: unknown): string[] {
  if (!error) return [];

  const messages: string[] = [];
  if (typeof error === 'string') {
    messages.push(error);
    return messages;
  }
  if (typeof error !== 'object') return messages;

  const e = error as { message?: unknown; graphQLErrors?: Array<{ message?: unknown }> };
  if (typeof e.message === 'string') messages.push(e.message);
  if (Array.isArray(e.graphQLErrors)) {
    for (const gqlError of e.graphQLErrors) {
      if (gqlError && typeof gqlError.message === 'string') {
        messages.push(gqlError.message);
      }
    }
  }
  return messages;
}

export function classifyQuotaError(error: unknown): QuotaLimitKind | null {
  const messages = collectErrorMessages(error);
  if (messages.length === 0) return null;

  for (const { kind, marker } of QUOTA_ERROR_MARKERS) {
    if (messages.some((message) => message.includes(marker))) {
      return kind;
    }
  }
  return null;
}
